import {connect} from "redux-vue";
import SlideTemplate from "./SlideTemplate";
import * as appActions from "../actions/app";

const ConclusionSlide = {
  props: ['reset'],

  methods: {
    handleContinue() {
      window.postMessage('nextActivity');
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    return (
      <SlideTemplate>
        <div class="p-6 py-10 lg:p-10 lg:pt-20 lg:pb-16">
          <div class="lg:px-20">
            <p class="text-brand-blue-600 text-3xl lg:text-5xl font-bold mb-6 leading-none">
              Conclusion
            </p>

            <p class="text-lg lg:text-2xl leading-snug">
              You have finished this section of the module! If you would like, you can retry the simulation to see how
              things could have gone differently.
              <br/><br/>
              When you are ready, continue to the final section of this module, where you reflect on how you can apply
              what you have learned about change management to your own real world situations.
            </p>

            <div class="flex flex-col lg:flex-row items-start mt-8 lg:mt-16 leading-none lg:leading-normal">
              <button type="button" onClick={this.reset}
                      class="rounded-full bg-brand-orange-700 text-white uppercase py-2 lg:py-1 px-8 lg:px-12 lg:text-2xl hover:bg-orange-700 focus:outline-none transition-colors duration-100">
                Retry Simulation
              </button>
              <div class="h-4 w-8"></div>
              <button type="button" onClick={this.handleContinue}
                      class="rounded-full bg-brand-orange-700 text-white uppercase py-2 lg:py-1 px-8 lg:px-12 lg:text-2xl hover:bg-orange-700 focus:outline-none transition-colors duration-100">
                Continue
              </button>
            </div>

          </div>
        </div>
      </SlideTemplate>
    );
  }
};

function mapStateToProps(state) {
  return {};
}

function mapActionToProps(dispatch) {
  return {
    reset: () => dispatch(appActions.reset()),
  };
}

export default connect(mapStateToProps, mapActionToProps)(ConclusionSlide);
